
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/value-proposition",
      function () {
        return require("private-next-pages/download/value-proposition/index.tsx");
      }
    ]);
  